<template>
  <div class="form-check" :class="computedStyleClasses">
    <input
      :id="id"
      ref="input"
      :type="inputType"
      class="form-check-input"
      :role="control"
      :aria-checked="m_checked"
      :name="group"
      :disabled="disabled"
      :required="required"
      :checked="checked"
      :value="value"
      :tabindex="tabindex"
      @change="update"
    />

    <!-- Label -->
    <label class="form-check-label" :class="labelComputedClasses" :for="id">
      <slot name="label_text">{{ label }}</slot>
      <ips-tooltip v-if="tooltip" :tooltip="tooltip">
        <template slot="tip">
          <ips-icon icon="ico-help"></ips-icon>
        </template>
      </ips-tooltip>
    </label>
  </div>
</template>

<script>
import { isArray } from '../../../utils';
import { formFieldsMixin } from './../../../mixins/index.js';
import IpsIcon from '@ipscape/ips-icon';
import IpsTooltip from '@ipscape/ips-tooltip';

// ToDo: Add prop for sizing, fix inline vs stacked CSS
export default {
  name: 'IpsCheckbox',
  components: {
    IpsIcon,
    IpsTooltip,
  },
  mixins: [formFieldsMixin],
  props: {
    control: {
      name: 'control',
      description: 'The control type of the checkbox',
      type: String,
      required: true,
      validator: (value) => ['checkbox', 'radio', 'switch'].indexOf(value) !== -1,
    },
    group: {
      name: 'group',
      description: 'The variant style of the badge',
      type: String,
      default: null,
      required: false,
    },
    checked: {
      name: 'checked',
      description: 'Makes checkbox checked if true',
      type: Boolean,
      required: false,
    },
    initValue: {
      name: 'initValue',
      description: 'The initial value',
      type: Boolean,
      required: false,
    },
    indeterminate: {
      name: 'indeterminate',
      description: 'Makes it indeterminate if true',
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      m_checked: this.initValue,
    };
  },
  computed: {
    isSwitch() {
      // Custom switch styling
      return this.control === 'switch';
    },
    isRadio() {
      // Custom switch styling
      return this.control === 'radio';
    },
    computedStyleClasses() {
      const classesArray = ['form-check'];
      if (typeof this.classes === 'object') {
        this.classes.forEach((cls) => {
          classesArray.push(cls);
        });
      }
      if (this.control === 'switch') {
        classesArray.push('form-switch');
      }
      return classesArray;
    },
    inputType() {
      if (this.control === 'radio') return 'radio';
      return 'checkbox';
    },
  },
  watch: {
    computedLocalChecked(newVal) {
      this.$emit('input', newVal);
      if (this.$refs && this.$refs.input) {
        this.$emit('update:indeterminate', this.$refs.input.indeterminate);
      }
    },
    indeterminate(newVal) {
      this.setIndeterminate(newVal);
    },
  },
  mounted() {
    this.$nextTick(() => {
      // Set initial indeterminate state
      this.setIndeterminate(this.indeterminate);
    });
  },
  methods: {
    update(event) {
      if (this.isRadio) {
        this.m_checked = event.target.value;
        this.$emit('change', this.m_checked);
      } else {
        this.m_checked = event.target.checked;
        this.$emit('change', this.m_checked);
      }
    },
    setIndeterminate(state) {
      // Indeterminate only supported in single checkbox mode
      if (isArray(this.computedLocalChecked)) {
        // TODO fix
        // state = false;
      }
      if (this.$refs && this.$refs.input) {
        this.$refs.input.indeterminate = state;
        // Emit update event to prop
        this.$emit('update:indeterminate', state);
      }
    },
  },
};
</script>
